import { gql, useQuery } from "@apollo/client";
import dayjs from "dayjs";

const GetUserStatisticsQuery = gql`
  query getUserStatistics(
    $fromDay: String!
    $toDay: String!
    $timezone: String!
  ) {
    getUserStatistics(fromDay: $fromDay, toDay: $toDay, timezone: $timezone) {
      newUsersPerDay {
        day
        userCount
      }
      loggedInLast7DaysCount
      loggedInLast30DaysCount
    }
  }
`;

export type NewUsersOnDay = {
  day: string;
  userCount: number;
};

export type UserStatistics = {
  newUsersPerDay: NewUsersOnDay[];
  loggedInLast7DaysCount: number;
  loggedInLast30DaysCount: number;
};

export function useUserStatistics({
  fromDay,
  toDay,
}: {
  fromDay: string;
  toDay: string;
}) {
  const { data, loading, error } = useQuery<{
    getUserStatistics: UserStatistics;
  }>(GetUserStatisticsQuery, {
    fetchPolicy: "cache-and-network",
    variables: { fromDay, toDay, timezone: dayjs.tz.guess() },
  });

  return {
    statistics: data?.getUserStatistics ?? null,
    loading: loading && !data,
    error,
  };
}
